class NewsLetterSignupDto {
    public identifiers: Identifiers = new Identifiers();
    public dataFields: DataFields = new DataFields;
    public lists: string[] = [];
    public preferences: Preferences[] = [];
    public consentRecords: ConsentRecord[] = [];

}
class DataFields {
    [key: string]: any;
}

class Identifiers {
    public email: string;
}

class Preferences {
    public id: number;
    public isOptedIn: boolean;
}

class ConsentRecord{
    public text: string;
    public dateTimeConsented: Date;
}


export { NewsLetterSignupDto };